import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

export const SUPPORTED_LANGS = [
  { code: 'en', name: 'English', dir: 'ltr' },
  { code: 'es', name: 'Español', dir: 'ltr' },
  { code: 'fr', name: 'Français', dir: 'ltr' },
  { code: 'ar', name: 'العربية', dir: 'rtl' },
] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

function applyDocDirection(lng: string) {
  const langConfig = SUPPORTED_LANGS.find((l) => l.code === lng);
  if (langConfig && typeof document !== 'undefined') {
    document.documentElement.lang = lng;
    document.documentElement.dir = langConfig.dir;
  }
}

i18n.on('languageChanged', applyDocDirection);
// Apply on load (e.g. persisted Arabic)
applyDocDirection(i18n.language);

export default i18n;